<template>
	<CardHeader
		:class="cn(propertyCardHeaderBodyVariants({ size, variant }), props.class)"
	>
		<PropertyCardCarousel
			v-bind="props"
			:is-mouse-over-card-header="isMouseOverCardHeader"
			:card-position="props.cardPosition"
			:section="props.section"
		/>

		<div class="absolute top-0 z-20 flex w-full justify-between p-4">
			<Badge
				v-if="property.isExclusive"
				class="size-fit text-xs font-medium tracking-wider"
			>
				Exclusivo
			</Badge>
		</div>

		<slot />
	</CardHeader>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import type { Property, PropertyImage } from '~/core/entities/property';
import type { SectionName } from '~/types/mixpanel';

import { Badge } from '../ui/badge';
import { CardHeader } from '../ui/card';

import { cn } from '@/utils';
import { propertyCardHeaderBodyVariants } from '.';

export interface CarouselItem extends PropertyImage {}

export type PropertyCardHeaderProps = {
	class?: HTMLAttributes['class'];
	isFavorited?: boolean;
	property: Property;
	isMouseOverCardHeader?: boolean;
	size: 'sm' | 'md' | 'lg';
	variant: 'fullFace' | 'whiteBackground' | 'transparentBackground';
	cardPosition?: number;
	section?: SectionName;
};

const props = withDefaults(defineProps<PropertyCardHeaderProps>(), {
	size: 'sm',
	isFavorited: false
});
</script>
